<template>
  <AdminInputSingleSelect
    v-on="$listeners"
    v-bind="{ ...$attrs, ...$props }"
    :size="size"
    :disabled="disabled"
    @change="update"
  />
</template>

<script>
import { Model } from '@vuex-orm/core'
import AdminInputSingleSelect from '@/components/AdminInputSingleSelect'
export default {
  name: 'AdminCellSingleSelect',
  components: { AdminInputSingleSelect },
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    fieldName: {
      type: String,
      require: true,
    },
    id: {
      type: [String, Number],
      require: true,
    },
    size: {
      type: String,
      default: 'large',
    },
  },
  computed: {},
  methods: {
    async update(selection) {
      if ('function' === typeof this.Model.updateModel) {
        const fields = { [this.fieldName]: selection }
        this.disabled = true
        try {
          await this.Model.updateModel(this.id, fields)
          this.error = false
        } catch (error) {
          this.error = true
        } finally {
          this.disabled = false
        }
      }
    }, // toggle
  },
  data() {
    return {
      error: false,
      disabled: false,
    }
  },
}
</script>

<style>
.admin-list-checkbox {
  cursor: pointer;
}
</style>
